var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes);
    global.propTypes = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _propTypes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _propTypes = _interopRequireDefault(_propTypes);

  var image = _propTypes.default.shape({
    url: _propTypes.default.string.isRequired,
    width: _propTypes.default.number.isRequired,
    height: _propTypes.default.number.isRequired,
    alternateResolutions: _propTypes.default.array,
    blurImages: _propTypes.default.array,
    format: _propTypes.default.string
  });

  var marking = _propTypes.default.shape({
    code: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  });

  var stickers = _propTypes.default.shape({
    code: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  });

  var warning = _propTypes.default.shape({
    code: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  });

  var kindMap = {
    PLAYLIST: 'arte-next-playlist',
    PLAYLIST_LIVE: 'arte-next-playlist',
    PROGRAM_PRESSE: 'arte-download-round',
    TV_SERIES: 'arte-next-collection',
    MAGAZINE: 'arte-next-collection',
    TOPIC: 'arte-next-collection',
    PARTNER: 'arte-next-collection'
  };

  var sectionFooter = _propTypes.default.shape({
    label: _propTypes.default.string,
    href: _propTypes.default.string,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      href: _propTypes.default.string
    }))
  });

  var europeanFooter = _propTypes.default.string;
  var legacyFooter = _propTypes.default.string;

  var mainFooter = _propTypes.default.arrayOf(sectionFooter);

  var partnerFooter = _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    href: _propTypes.default.string
  }));

  var breakpointFormat = {
    xsmall: 'landscape',
    small: 'landscape',
    medium: 'landscape',
    large: 'landscape',
    xlarge: 'landscape',
    xxlarge: 'landscape'
  };
  var warned = {};
  /**
   * If a prop is deprecated, this could communicate with a warning
   * @param {PropTypes} propType
   * @param {String} explanation
   */

  var deprecated = function deprecated(propType, explanation) {
    return function (props, propName, componentName, type, longPropName) {
      if (props[propName] !== null && process.env.NODE_ENV === 'development') {
        var message = "\"".concat(longPropName || propName, "\" property of \"").concat(componentName, "\" has been deprecated.\n\t").concat(explanation);

        if (!warned[message]) {
          // eslint-disable-next-line no-console
          console.warn(message);
          warned[message] = true;
        }
      }

      for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
        rest[_key - 5] = arguments[_key];
      }

      return propType.apply(void 0, [props, propName, componentName, type, longPropName].concat(rest));
    };
  };

  var _default = {
    breakpointFormat: breakpointFormat,
    deprecated: deprecated,
    image: image,
    kindMap: kindMap,
    stickers: stickers,
    marking: marking,
    warning: warning,
    europeanFooter: europeanFooter,
    mainFooter: mainFooter,
    sectionFooter: sectionFooter,
    partnerFooter: partnerFooter,
    legacyFooter: legacyFooter
  };
  _exports.default = _default;
});